import { FC } from 'react'

import CustomLector from 'components/parts/custom-lector/custom-lector'
import AuthorLector from 'components/parts/author-lector/author-lector'

import { ILectur } from 'constants/types/common.types'

import styles from './webinar-lectors.module.scss'

interface ILectorsBlock {
  Lecturs: ILectur[]
  lecturName?: string
}

const CustomAuthor = (props: any) => (
  <AuthorLector
    {...props}
    lectorData={{ ...props.lectorData, big: true }}
    modificator={styles.authorLine}
    withRegalia
  />
)

const getLectursCount = (LecturArr: ILectur[], lectur: string | undefined) => {
  let count = 0
  if (lectur) {
    count += lectur.split(',').length
  }
  count += (LecturArr || []).length
  return count > 1 ? 'Лекторы' : 'Лектор'
}

const LectorsBlock: FC<ILectorsBlock> = ({ Lecturs, lecturName }: ILectorsBlock) => {
  return (
    <div className={styles.authorBlock}>
      <h3 className={styles.lectorTitle}>{getLectursCount(Lecturs, lecturName)}</h3>
      <div>
        {Lecturs?.map((data) => (
          <AuthorLector
            key={data.id}
            lectorData={{ ...data, big: true }}
            modificator={styles.authorLine}
            withLink
            withRegalia
          />
        ))}
        <CustomLector lecturName={lecturName} LectorComponent={CustomAuthor} />
      </div>
    </div>
  )
}

export default LectorsBlock
